module.exports = __webpack_public_path__ + "static/fonts/DejaVuSans-BoldOblique.e5947ee.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/shared-components/spreadsheet/kendoui/fonts/DejaVu/DejaVuSans-BoldOblique.ttf?v=1.1
// module id = 1636
// module chunks = 28